import { ColumnRankNoResult, ColumnName, ColumnNoc, ColumnResult, ColumnExpander, ColumnStartOrder, ColumnRecords, CellRank } from "components/common/TableColumns"
import Label from "components/general/Label"
import { findArray } from 'helpers/utils'

export function ColumnRank({
    disableSort = false,
    className = 'text-end',
    headerClassName = 'text-end w-5 text-nowrap',
    label = 'HeaderRank',
    remove = false
}) {
    return (
        {
            Header: <Label data={label} />,
            accessor: 'sortOrder',
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Rank',
            remove: remove,
            Cell: (props) => {
                let isBUW = props.cell.row.original.resultIrm === 'BUW'
                if (isBUW)
                    return props.cell.row.original.resultRank
                return <CellRank node={props.cell.row.original} ></CellRank>

            }
        }
    )
}

export function ColumnProgression({
    disableSort = true,
    className = 'text-center',
    headerClassName = 'text-center w-5',
    remove = false
}) {
    return (
        {
            Header: <Label data='HeaderProgression' />,
            remove: remove,
            accessor: 'qualificationMark',// accessor is the "key" in the data 
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'QualMark',
        }
    )
}

function createIntermediates(intermediatePoints, breakPoint) {
    let intermediates = []
    intermediatePoints.map(int => {
        let number = int.pos
        intermediates.push(
            {
                Header: int.pos === 'F' ? <Label data='HeaderTime'/> : `${int.value}m`,
                className: 'text-end',
                headerClassName: 'text-end w-10',
                disableSortBy: true, //habilita poder ordenar
                id: `Intermediate ${number}`,
                remove: false,
                accessor: (props) => {
                    let value = findArray(props?.extendedResults, { er_code: ['INTERMEDIATE'], er_type: ['PROGRESS'], er_pos: [`${number}`] }).er_value;
                    let rank = findArray(props?.extendedResults, { er_code: ['INTERMEDIATE'], er_type: ['PROGRESS'], er_pos: [`${number}`] }).er_rank;
                    if (rank && (breakPoint === "sm" || breakPoint === "xs"))
                        return value
                    else if (rank)
                        return <>{value} ({rank})</>
                    return value
                }
            }
        )
    })
    return intermediates
}

function createIntermediatesSM(intermediatePoints, breakPoint, leaderPos) {
    let intermediates = []

    if(intermediatePoints.length > 2 && leaderPos){
        if(Number(leaderPos) <= 2 && leaderPos !== "F"){
            intermediatePoints = intermediatePoints.filter(int => int.pos === "1" || int.pos === "2")
        } 
        else if(leaderPos === "F"){
            intermediatePoints = intermediatePoints.filter(int => int.pos === (intermediatePoints.length-1).toString() || int.pos === "F")
        }
        else{
            intermediatePoints = intermediatePoints.filter(int => int.pos === (Number(leaderPos)-1).toString() || int.pos === leaderPos)
        }       
    }
    else {
        intermediatePoints = intermediatePoints.filter(int => int.pos === intermediatePoints[0]?.pos || int.pos === intermediatePoints[1]?.pos)
    }

    intermediatePoints.map(int => {
        let number = int.pos
        intermediates.push(
            {
                Header: int.pos === 'F' ? <Label data='HeaderTime'/> : `${int.value}m`,
                className: 'text-end',
                headerClassName: 'text-end w-10',
                disableSortBy: true, //habilita poder ordenar
                id: `Intermediate ${number}`,
                remove: false,
                accessor: (props) => {
                    let value = findArray(props?.extendedResults, { er_code: ['INTERMEDIATE'], er_type: ['PROGRESS'], er_pos: [`${number}`] }).er_value;
                    let rank = findArray(props?.extendedResults, { er_code: ['INTERMEDIATE'], er_type: ['PROGRESS'], er_pos: [`${number}`] }).er_rank;
                    if (rank && (breakPoint === "sm" || breakPoint === "xs"))
                        return value
                    else if (rank)
                        return <>{value} ({rank})</>
                    return value
                }
            }
        )
    })
    return intermediates
}

export function TableColumnsStartList(isTimeTrial = false) {
    if (isTimeTrial) {
        return (
            [
                ColumnStartOrder({}),
                ColumnNoc({}),
                ColumnName({ label: "HeaderCrew" }),
                ColumnExpander({})
            ]
        )
    }
    else return (
        [
            ColumnStartOrder({ label: "HeaderLane" }),
            ColumnNoc({}),
            ColumnName({ label: "HeaderCrew" }),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsFinished(isTimeTrial = false) {
    if (isTimeTrial) {
        return (
            [
                ColumnRank({}),
                ColumnNoc({}),
                ColumnName({ label: "HeaderCrew" }),
                ColumnResult({ label: "HeaderTime" }),
                ColumnProgression({}),
                ColumnRecords({}),
                ColumnExpander({})
            ]
        )
    }
    else return (
        [
            ColumnRank({}),
            ColumnNoc({}),
            ColumnName({ label: "HeaderCrew" }),
            ColumnResult({ label: "HeaderTime" }),
            ColumnProgression({}),
            ColumnRecords({}),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsFinishedSM(isTimeTrial = false) {
    if (isTimeTrial) {
        return (
            [
                ColumnRank({}),
                ColumnNoc({}),
                ColumnName({ label: "HeaderCrew" }),
                ColumnResult({ label: "HeaderTime" }),
                ColumnRecords({}),
                ColumnExpander({})
            ]
        )
    }
    else return (
        [
            ColumnRank({}),
            ColumnNoc({}),
            ColumnName({ label: "HeaderCrew" }),
            ColumnResult({ label: "HeaderTime" }),
            ColumnRecords({}),
            ColumnExpander({})
        ]
    )
}

export function TableColumnsLive(isTimeTrial = false, intermediatePoints, breakPoint) {
    let intermediates = createIntermediates(intermediatePoints, breakPoint)
    if (isTimeTrial) {
        return (
            [
                ColumnRank({}),
                ColumnStartOrder({}),
                ColumnNoc({}),
                ColumnName({ label: "HeaderCrew" }),
                ...intermediates,
                ColumnExpander({})
            ]
        )
    }
    else return (
        [
            ColumnRank({}),
            ColumnStartOrder({ label: "HeaderLane" }),
            ColumnNoc({}),
            ColumnName({ label: "HeaderCrew" }),
            ...intermediates,
            ColumnExpander({})
        ]
    )

}

export function TableColumnsLiveSM(isTimeTrial = false, intermediatePoints, breakPoint, leaderPos) {
    let intermediates = createIntermediatesSM(intermediatePoints, breakPoint, leaderPos)
    if (isTimeTrial) {
        return (
            [
                ColumnRank({}),
                ColumnStartOrder({}),
                ColumnNoc({}),
                ColumnName({ label: "HeaderCrew" }),
                ...intermediates,
                ColumnExpander({})
            ]
        )
    }
    else return (
        [
            ColumnRank({}),
            ColumnStartOrder({ label: "HeaderLane" }),
            ColumnNoc({}),
            ColumnName({ label: "HeaderCrew" }),
            ...intermediates,
            ColumnExpander({})
        ]
    )

}

export function ColumnDistance({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-15',
    remove = false
}) {
    return (
        {
            Header: <Label data='HeaderDistanceToFinish' sport='ROW' />,
            remove: remove,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'Distance',
            accessor: (props) => {
                let value = findArray(props?.extendedResultsCurrent, { er_code: ['DIST'] }).er_value2
                return value
            }
        }
    )
}

export function ColumnSpeed({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-15',
    remove = false
}) {
    return (
        {
            Header: <Label data='HeaderSpeed' sport='ROW' />,
            remove: remove,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'SpeedKMH',
            accessor: (props) => {
                let value = findArray(props?.extendedResultsCurrent, { er_code: ['SPEED_KMH'] }).er_value
                return value
            }
        }
    )
}

export function ColumnStrokeRate({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-15',
    remove = false
}) {
    return (
        {
            Header: <Label data='HeaderStrokeRate' sport='ROW' />,
            remove: remove,
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'StrokeRate',
            accessor: (props) => {
                let value = findArray(props?.extendedResultsCurrent, { er_code: ['RATE'] }).er_value
                return value
            }
        }
    )
}

export function TableColumnsStats() {
    return (
        [
            ColumnRank({}),
            ColumnStartOrder({ label: "HeaderLane" }),
            ColumnNoc({}),
            ColumnName({ label: "HeaderCrew" }),
            ColumnDistance({}),
            ColumnSpeed({}),
            ColumnStrokeRate({}),
        ]
    )
}